import GoogleSVG from "../../assets/images/icons/google.svg";
import {useGoogleLogin} from "@react-oauth/google";

const GoogleLoginButton = ({loadingSocials, getResponseData , text = "Sign in with Google"}) => {

  const googleCallbackResponse = useGoogleLogin({
    onSuccess: response => getResponseData({token: response['access_token'], platform: 'GOOGLE'}),
  });

  return (
    <button onClick={() => googleCallbackResponse()} type="button"
            className="btn btn-block  btn-white border-dark my-4 google-button-wrapper">
      <img className="google-button" src={GoogleSVG} alt="Google"/>
      {text}
      {loadingSocials ? <>&nbsp;<i className="zmdi zmdi-spinner zmdi-hc-spin"/> </> : ""}
    </button>
  )
};

export default GoogleLoginButton;
